(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-add-similar-section-but-2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function each(root, sel, fn) { Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }

    function setModel(root, group, i) {
      ['.bam-lineup__shots', '.bam-lineup__stack'].forEach(function (wrap) {
        each(root, wrap + '[data-bam-group="' + group + '"] [data-bam-i]', function (el) {
          el.classList.toggle('is-active', el.getAttribute('data-bam-i') === String(i));
        });
      });
      ['.bam-lineup__models', '.bam-lineup__rail'].forEach(function (wrap) {
        each(root, wrap + '[data-bam-group="' + group + '"] [data-bam-i]', function (el) {
          var on = el.getAttribute('data-bam-i') === String(i);
          el.classList.toggle('is-active', on);
          el.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      });
    }

    function setGroup(root, group) {
      each(root, '[data-bam-group]', function (el) {
        if (el.getAttribute('data-bam-group') === String(group)) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
      each(root, '[data-bam-tab]', function (b) {
        var on = b.getAttribute('data-bam-tab') === String(group);
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      setModel(root, group, 0);
    }

    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-bam-tab],[data-bam-i]');
      if (!t) return;
      var root = t.closest('[data-bam-lineup]');
      if (!root) return;

      var tab = t.getAttribute('data-bam-tab');
      if (tab) { setGroup(root, tab); return; }

      var wrap = t.closest('[data-bam-group]');
      if (!wrap) return;
      setModel(root, wrap.getAttribute('data-bam-group'), t.getAttribute('data-bam-i'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-add-similar-section-but-3"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function each(root, sel, fn) {
      Array.prototype.forEach.call(root.querySelectorAll(sel), fn);
    }

    function setModel(root, group, i) {
      ['.bam-lineup__shots', '.bam-lineup__stack'].forEach(function (wrap) {
        each(root, wrap + '[data-bam-group="' + group + '"] [data-bam-i]', function (el) {
          el.classList.toggle('is-active', el.getAttribute('data-bam-i') === String(i));
        });
      });
      ['.bam-lineup__models', '.bam-lineup__rail'].forEach(function (wrap) {
        each(root, wrap + '[data-bam-group="' + group + '"] [data-bam-i]', function (el) {
          var on = el.getAttribute('data-bam-i') === String(i);
          el.classList.toggle('is-active', on);
          el.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      });
    }

    function setGroup(root, group) {
      each(root, '[data-bam-group]', function (el) {
        if (el.getAttribute('data-bam-group') === String(group)) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
      each(root, '[data-bam-tab]', function (b) {
        var on = b.getAttribute('data-bam-tab') === String(group);
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      setModel(root, group, 0);
    }

    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-bam-tab],[data-bam-i]');
      if (!t) return;
      var root = t.closest('[data-bam-lineup]');
      if (!root) return;

      var tab = t.getAttribute('data-bam-tab');
      if (tab) {
        setGroup(root, tab);
        return;
      }

      var wrap = t.closest('[data-bam-group]');
      if (!wrap) return;
      setModel(root, wrap.getAttribute('data-bam-group'), t.getAttribute('data-bam-i'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-add-similar-section-but-4"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function each(root, sel, fn) {
      Array.prototype.forEach.call(root.querySelectorAll(sel), fn);
    }

    function setModel(root, group, i) {
      ['.bam-lineup__shots', '.bam-lineup__stack'].forEach(function (wrap) {
        each(root, wrap + '[data-bam-group="' + group + '"] [data-bam-i]', function (el) {
          el.classList.toggle('is-active', el.getAttribute('data-bam-i') === String(i));
        });
      });
      ['.bam-lineup__models', '.bam-lineup__rail'].forEach(function (wrap) {
        each(root, wrap + '[data-bam-group="' + group + '"] [data-bam-i]', function (el) {
          var on = el.getAttribute('data-bam-i') === String(i);
          el.classList.toggle('is-active', on);
          el.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      });
    }

    function setGroup(root, group) {
      each(root, '[data-bam-group]', function (el) {
        if (el.getAttribute('data-bam-group') === String(group)) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
      each(root, '[data-bam-tab]', function (b) {
        var on = b.getAttribute('data-bam-tab') === String(group);
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      setModel(root, group, 0);
    }

    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-bam-tab],[data-bam-i]');
      if (!t) return;
      var root = t.closest('[data-bam-lineup]');
      if (!root) return;

      var tab = t.getAttribute('data-bam-tab');
      if (tab) {
        setGroup(root, tab);
        return;
      }

      var wrap = t.closest('[data-bam-group]');
      if (!wrap) return;
      setModel(root, wrap.getAttribute('data-bam-group'), t.getAttribute('data-bam-i'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-add-similar-section-but-6"] && !Shopify.designMode) return;
  try {
    
(function () {
  function each(root, sel, fn) { Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }

  function setModel(root, group, i) {
    ['.bam-lineup__shots', '.bam-lineup__stack'].forEach(function (wrap) {
      each(root, wrap + '[data-bam-group="' + group + '"] [data-bam-i]', function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-bam-i') === String(i));
      });
    });
    ['.bam-lineup__models', '.bam-lineup__rail'].forEach(function (wrap) {
      each(root, wrap + '[data-bam-group="' + group + '"] [data-bam-i]', function (el) {
        var on = el.getAttribute('data-bam-i') === String(i);
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
  }

  function setGroup(root, group) {
    each(root, '[data-bam-group]', function (el) {
      if (el.getAttribute('data-bam-group') === String(group)) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
    each(root, '[data-bam-tab]', function (b) {
      var on = b.getAttribute('data-bam-tab') === String(group);
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    setModel(root, group, 0);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-bam-tab],[data-bam-i]');
    if (!t) return;
    var root = t.closest('[data-bam-lineup]');
    if (!root) return;

    var tab = t.getAttribute('data-bam-tab');
    if (tab) { setGroup(root, tab); return; }

    var wrap = t.closest('[data-bam-group]');
    if (!wrap) return;
    setModel(root, wrap.getAttribute('data-bam-group'), t.getAttribute('data-bam-i'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-add-similar-section-but-7"] && !Shopify.designMode) return;
  try {
    
(function () {
  function each(root, sel, fn) { Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }

  function setModel(root, group, i) {
    ['.bam-lineup__shots', '.bam-lineup__stack'].forEach(function (wrap) {
      each(root, wrap + '[data-bam-group="' + group + '"] [data-bam-i]', function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-bam-i') === String(i));
      });
    });
    ['.bam-lineup__models', '.bam-lineup__rail'].forEach(function (wrap) {
      each(root, wrap + '[data-bam-group="' + group + '"] [data-bam-i]', function (el) {
        var on = el.getAttribute('data-bam-i') === String(i);
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
  }

  function setGroup(root, group) {
    each(root, '[data-bam-group]', function (el) {
      if (el.getAttribute('data-bam-group') === String(group)) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
    each(root, '[data-bam-tab]', function (b) {
      var on = b.getAttribute('data-bam-tab') === String(group);
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    setModel(root, group, 0);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-bam-tab],[data-bam-i]');
    if (!t) return;
    var root = t.closest('[data-bam-lineup]');
    if (!root) return;

    var tab = t.getAttribute('data-bam-tab');
    if (tab) { setGroup(root, tab); return; }

    var wrap = t.closest('[data-bam-group]');
    if (!wrap) return;
    setModel(root, wrap.getAttribute('data-bam-group'), t.getAttribute('data-bam-i'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-add-similar-section-but"] && !Shopify.designMode) return;
  try {
    
(function () {
  function each(root, sel, fn) {
    Array.prototype.forEach.call(root.querySelectorAll(sel), fn);
  }

  function setActiveModel(root, group, index) {
    ['.product-lineup__shots', '.product-lineup__stack'].forEach(function (wrapper) {
      each(root, `${wrapper}[data-product-lineup-group="${group}"] [data-product-lineup-index]`, function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-product-lineup-index') === String(index));
      });
    });
    ['.product-lineup__models', '.product-lineup__rail'].forEach(function (wrapper) {
      each(root, `${wrapper}[data-product-lineup-group="${group}"] [data-product-lineup-index]`, function (el) {
        const on = el.getAttribute('data-product-lineup-index') === String(index);
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
  }

  function setActiveGroup(root, group) {
    each(root, '[data-product-lineup-group]', function (el) {
      if (el.getAttribute('data-product-lineup-group') === String(group)) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });
    each(root, '[data-product-lineup-tab]', function (button) {
      const on = button.getAttribute('data-product-lineup-tab') === String(group);
      button.classList.toggle('is-active', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    setActiveModel(root, group, 0);
  }

  document.addEventListener('click', function (e) {
    const target = e.target.closest('[data-product-lineup-tab], [data-product-lineup-index]');
    if (!target) return;

    const root = target.closest('[data-product-lineup]');
    if (!root) return;

    const tab = target.getAttribute('data-product-lineup-tab');
    if (tab) {
      setActiveGroup(root, tab);
      return;
    }

    const wrapper = target.closest('[data-product-lineup-group]');
    if (!wrapper) return;
    setActiveModel(root, wrapper.getAttribute('data-product-lineup-group'), target.getAttribute('data-product-lineup-index'));
  });
})();

  } catch(e) { console.error(e); }
})();
})();
